import { URLS } from 'api/constants';
import { IWeights } from 'constants/types';
import { useQuery } from 'hooks/useQuery';
import { apiGet } from 'lib/api/client';
import { HookQueryOptions, queryKey } from './shared';

export const useWeightByNameQuery = (
  payload: { name: string },
  options?: HookQueryOptions
) =>
  useQuery<IWeights>(
    queryKey('weights.byName', payload),
    () => apiGet<IWeights>(`${URLS.WEIGHTS_BY_NAME}${payload?.name ?? ''}`),
    { skip: options?.skip || !payload?.name }
  );
